import type { ColumnDef } from "@tanstack/react-table";
import { Text } from "@volca/ui/components/ui/text";
import type { PayrollStatementNotificationRecipient } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import type { RecipientNoteColumnOptions } from "./types";

export const NoteCol = ({
  noteDrafts,
}: RecipientNoteColumnOptions): ColumnDef<
  PayrollStatementNotificationRecipient,
  unknown
> => ({
  id: "note",
  enableSorting: false,
  header: () => <span>Note</span>,
  cell: ({ row }) => {
    const note = (
      noteDrafts[row.original.technician_id] ??
      row.original.note ??
      ""
    ).trim();

    return note ? (
      <Text
        variant="caption"
        tone="muted"
        className="line-clamp-3 whitespace-pre-line"
        title={note}
      >
        {note}
      </Text>
    ) : null;
  },
});
